module.exports = __webpack_public_path__ + "static/media/navidad11.d008c9e2.webp";